import { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import Footer from "../components/Footer";
import routes from "./config";
import { Styles } from "../styles/styles";
import AuthGuard from "../components/AuthGuard";

const Router = () => {
  return (
    <Suspense fallback={null}>
      <Styles />
      <Switch>
        {routes.map((routeItem) => {
          const LazyComponent = lazy(() => import(`../pages/${routeItem.component}`));
          return (
            <Route
              key={routeItem.component}
              path={routeItem.path}
              exact={routeItem.exact}
              component={routeItem.guard === true
                ? (props: any) => <AuthGuard child={<LazyComponent {...props} />} />
                : (props: any) => <LazyComponent {...props} />}
            />
          );
        })}
      </Switch>
      <Footer />
    </Suspense>
  );
};

export default Router;
